import React, { useCallback, useEffect, useState } from "react";
import { IonToast } from "@ionic/react";
import PageLayout from "../../layouts/PageLayout";
import { FirebaseAnalytics } from "@ionic-native/firebase-analytics";
import http from "axios";
import firebase from "firebase";
import ErrorMessage from "components/ErrorMessage";
import Title from "components/Title";
import Input from "components/Input";
import Button from "components/Button";

interface BulkMacFlagsBody {
  carton: number;
  brand: string;
}

interface BulkMacFlagsResponse {
  result: string;
}

const BulkMacFlags: React.FC<{}> = () => {
  const [carton, setCarton] = useState<string>("");
  const [brand, setBrand] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [toastMessage, setToastMessage] = useState<string>("");

  useEffect(() => {
    FirebaseAnalytics.logEvent("init_page", {
      page: "admin_bulk_macflags",
    });
  }, []);

  const submit = useCallback(
    (form) => {
      if (form) {
        form.preventDefault();
      }
      firebase.analytics().logEvent("admin_bulk_macflags", {});
      FirebaseAnalytics.logEvent("admin_bulk_macflags", {});

      setError("");
      setToastMessage("");

      const body: BulkMacFlagsBody = {
        carton: parseInt(carton),
        brand: brand,
      };

      http
        .post<BulkMacFlagsResponse>(`/v1/admin/bulkmacflags`, body)
        .then((result) => {
          setToastMessage(result.data.result);
        })
        .catch((e) => {
          setError(e.message);
        });
    },
    [carton, brand]
  );

  return (
    <PageLayout showEnvironment={true}>
      <Title title="Bulk Mac Flags" />
      <form onSubmit={(e) => submit(e)}>
        <div className="basis-full">
          <Input
            className="my-4"
            id="carton"
            data-testid="carton-input"
            label=""
            inputProps={{
              value: carton,
              onChange: (e: any) => setCarton(e.target.value),
            }}
            type="text"
            placeholder="Carton"
          />
        </div>
        <div className="basis-full">
          <Input
            className="my-4"
            id="brand"
            data-testid="brand-input"
            label=""
            inputProps={{
              value: brand,
              onChange: (e: any) => setBrand(e.target.value),
            }}
            type="text"
            placeholder="Brand"
          />
        </div>
        <div className="flex flex-row gap-3">
          <Button
            type="submit"
            disabled={carton === "" || brand === ""}
            data-testid="submit"
          >
            Update
          </Button>
        </div>
        <ErrorMessage isText error={error} />
        <IonToast
          color="success"
          isOpen={!!toastMessage.length}
          onDidDismiss={() => setToastMessage("")}
          message={toastMessage}
          duration={5000}
        />
      </form>
    </PageLayout>
  );
};

export default BulkMacFlags;
